import styled from 'styled-components';

export const ErrorBoundaryWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 70%;
  margin-top: 100px;
`;
